interface IconProps {
  className?: string;
}

/** Back arrow of the mobile product bar on the DubaiExpress product page. */
const ArrowLeftIcon = ({ className }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    className={className}
  >
    <path d="M19 12H5m0 0 6-6m-6 6 6 6" />
  </svg>
);

export default ArrowLeftIcon;
